<template>
  <div class="pm-dialog-boardside-type">

    <div class="flex justify-center outer-area">
      <div class="vs-col candidate-list" v-for="(master,index) in masterList" :key="index" @mousedown="selectedId = (selectedId !== master.id) ? master.id : -1" >
        <vs-chip
          :color="(selectedId === master.id) ? '#346c88' : '#828282' "          
        >
          {{ 
            master.id === 1 ? '左' :
            master.id === 2 ? '右' : 
            master.id === 3 ? '左' :
            master.id === 4 ? '右' :
            master.id === 5 ? '？' : ""
          }}
          <feather-icon v-if="master.id === 3 || master.id === 4" icon="RefreshCwIcon"  svgClasses="h-4 w-4" class="pm-boardside-type-icon" />
        </vs-chip>
      </div>
    </div>

    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
      >
        保存
      </vs-button>
      <vs-button
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
      selectedId: -1,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return this.masterMap['boardside_type'];
    },
    enableSave() {
      return true; // ( this.selectedId && this.selectedId >= 0 );
    },
  },
  methods: {
    initData() {
      this.selectedId = this.valueMap ? this.valueMap.id : null;
    },
    onSubmit(isUpdateTimeStamp) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = this.selectedId;
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-boardside-type {
  .outer-area {
    padding: 1rem;
  }
  .candidate-list {
    margin:0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 3rem;
    }
  }
  .pm-boardside-type-icon {
    padding-left: 0.4rem;
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }
}
</style>

